exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".team-select-self-height{max-height:290px}div[popper-class='team-pop'] .yxt-scrollbar__wrap{height:290px}\n", ""]);

